module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.39a15ccd.mp3";